import axiosBackEnd from "../config/axios/axios-back-end";
import { message } from "antd";

export const rolesGetUserRoleData = async (data) => {
  const queryData = { role_id: data };
  let error = false;
  let returnData = undefined;
  const headers = {
    "Content-Type": "application/json",
  };
  try {
    const response = await axiosBackEnd.get("/api/roles", {
      params: queryData,
      headers: headers,
    });
    returnData = response?.data?.data[0];
    return {
      error,
      data:returnData,
    };
  } catch (err) {
    error = true;
    if (err.response) {
      const errorList = err.response.data.errors;
      if (errorList) {
        errorList.forEach((error) => message.error(error.msg));
      }
    } else {
      message.error(err.message);
    }
    return {
      error,
      data:returnData,
    };
  }
};

export const rolesGet = async () => {
  const url = `/api/roles`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};

export const mainRolesGet = async () => {
  const url = `/api/main-roles`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};